import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { canAccessArchivePage } from "../../../Archive/archive-permissions.ts"

import { lazyPage } from "../lazyPage.tsx"

const ArchivePage = lazyPage(() => import("../../../Archive/ArchivePage.tsx"))
export const archiveRoutes: RouteObject[] = [
  {
    path: RoutesPaths.archive.list,
    element: (
      <PermissionGate
        description={"You don't have permission to view the archive."}
        check={(permissions) => canAccessArchivePage(permissions)}
      >
        <ArchivePage />
      </PermissionGate>
    )
  }
]
